import RecipientWellWithFindControlViewState from 'owa-recipient-common/lib/store/schema/RecipientWellWithFindControlViewState';
import FindControlViewState from 'owa-recipient-common/lib/store/schema/FindControlViewState';

export default function isRecipientWellWithFindControlViewState(
    viewState: FindControlViewState | RecipientWellWithFindControlViewState
): boolean {
    return (viewState as RecipientWellWithFindControlViewState).recipients !== undefined;
}
